import { useLocation } from "react-router-dom";
import { Alert } from "@volca/ui/components/ui/alert";
import { Button } from "@volca/ui/components/ui/button";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { useGetBusiness } from "@/business/query";
import { useBusiness } from "@/core/business";
import { ONBOARDING_STEP } from "./constants";
import { hasOnboardingProducts, SIMPLE_ONBOARDING_PATHS } from "./routes";
import { NoOnboardingProducts } from "./simple-onboarding/no-onboarding-products";
import { OnboardingFlow } from "./simple-onboarding/onboarding-flow";
import { OnboardingLoadError } from "./simple-onboarding/onboarding-load-error";
import { ProductReadyRedirect } from "./simple-onboarding/product-ready-redirect";
import { useBusinessOnboarding } from "./simple-onboarding/shared-query";

const Onboarding = () => {
  const location = useLocation();
  const { businessId } = useBusiness();
  const businessQuery = useGetBusiness(businessId);
  const business = businessQuery.data;
  const completed = business?.onboarding_step === ONBOARDING_STEP.completed;
  const onboardingQuery = useBusinessOnboarding(
    businessId,
    Boolean(
      business &&
        !completed &&
        hasOnboardingProducts(business.enabled_products),
    ),
    location.pathname === SIMPLE_ONBOARDING_PATHS.forwardingGuides,
  );

  const retry = () => {
    void businessQuery.refetch();
    void onboardingQuery.refetch();
  };

  if (businessQuery.isLoading || onboardingQuery.isLoading) {
    return (
      <Stack gap={4} className="h-page w-full" align="center" justify="center">
        <Spinner layout="centered" />
      </Stack>
    );
  }
  if (business && completed)
    return <ProductReadyRedirect business={business} />;
  if (business && !hasOnboardingProducts(business.enabled_products))
    return <NoOnboardingProducts />;
  if (!business || !onboardingQuery.data) {
    return <OnboardingLoadError retry={retry} />;
  }
  return (
    <>
      {(businessQuery.isError || onboardingQuery.isError) && (
        <Alert color="danger">
          Could not refresh your setup information. Your input is retained.
          <Button variant="link" size="sm" onClick={retry}>
            Retry
          </Button>
        </Alert>
      )}
      <OnboardingFlow
        key={business.id}
        business={business}
        state={onboardingQuery.data}
      />
    </>
  );
};

export default Onboarding;
